<div class="payment-card normal-text">
  <div class="block">
    <div class="payment-card-info">{{ 'The following cards are accepted' | translate }}</div>
    <accepted-credit-cards [acceptedCreditCards]="acceptedCreditCards" (onCardClick)="onCardClick($event)" *ngIf="canPayWithCreditCard"></accepted-credit-cards>
    <div class="payment-card-info">{{ 'Amount to pay' | translate }}</div>
    <div class="payment-card-info amount">{{ amountToPay }}</div>
  </div>
  <div *ngIf="false && !isProduction" class="debug">{{ machineState }}</div>
  <div class="messages" *ngIf="creditCardMessageStore">
    <div [ngClass]="cssClassMessage">{{ creditCardMessageStore.message | translate }}</div>
    <div class="terminal-text">{{ creditCardMessageStore.terminalText | translate }}</div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-sm-6">
        <receipt-switcher *ngIf="showCardTerminalReceiptButton" [receiptType]='printReceiptTypeEnums.CardTerminalReceipt' [cssClass]="cardTerminalReceiptSwitcherStyle"></receipt-switcher>
      </div>
      <div class="col-sm-6">
        <receipt-switcher *ngIf="showReceiptButton" [receiptType]='printReceiptTypeEnums.OrderReceipt' [cssClass]="receiptSwitcherStyle"></receipt-switcher>
      </div>
    </div>
  </div>
</div>
